// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file consts/instrumentconsts.proto (package aurora.core.consts.instruments, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file consts/instrumentconsts.proto.
 */
export const file_consts_instrumentconsts: GenFile = /*@__PURE__*/
  fileDesc("Ch1jb25zdHMvaW5zdHJ1bWVudGNvbnN0cy5wcm90bxIeYXVyb3JhLmNvcmUuY29uc3RzLmluc3RydW1lbnRzKj4KDlNlY3VyaXR5U291cmNlEhYKElNPVVJDRV9VTlNQRUNJRklFRBAAEgsKB1BPTFlHT04QARIHCgNFREkQAipKChBTZWN1cml0eUNhdGVnb3J5EhgKFENBVEVHT1JZX1VOU1BFQ0lGSUVEEAASCgoGRVFVSVRZEAESEAoMRklYRURfSU5DT01FEAIq7QEKDFNlY3VyaXR5VHlwZRIdChlTRUNVUklUWV9UWVBFX1VOU1BFQ0lGSUVEEAASBgoCQ1MQARIHCgNQRkQQAhILCgdXQVJSQU5UEAMSCQoFUklHSFQQBBIICgRCT05EEAUSBwoDRVRGEAYSBgoCU1AQBxIHCgNBRFIQCBIICgRGVU5EEAkSCgoGQkFTS0VUEAoSCAoEVU5JVBALEgYKAkxUEAwSBgoCT1MQDRIHCgNHRFIQDhIJCgVPVEhFUhAPEggKBE5ZUlMQEBIICgRBR0VOEBESCAoERVFMSxASEgcKA0VUUxATEgYKAk5UEBRCKVonZ2l0bGFiLnBydmJsLmNvbS9hdXJvcmEvY29yZS9zcmMvY29uc3RzYgZwcm90bzM");

/**
 * @generated from enum aurora.core.consts.instruments.SecuritySource
 */
export enum SecuritySource {
  /**
   * @generated from enum value: SOURCE_UNSPECIFIED = 0;
   */
  SOURCE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: POLYGON = 1;
   */
  POLYGON = 1,

  /**
   * @generated from enum value: EDI = 2;
   */
  EDI = 2,
}

/**
 * Describes the enum aurora.core.consts.instruments.SecuritySource.
 */
export const SecuritySourceSchema: GenEnum<SecuritySource> = /*@__PURE__*/
  enumDesc(file_consts_instrumentconsts, 0);

/**
 * @generated from enum aurora.core.consts.instruments.SecurityCategory
 */
export enum SecurityCategory {
  /**
   * @generated from enum value: CATEGORY_UNSPECIFIED = 0;
   */
  CATEGORY_UNSPECIFIED = 0,

  /**
   * @generated from enum value: EQUITY = 1;
   */
  EQUITY = 1,

  /**
   * @generated from enum value: FIXED_INCOME = 2;
   */
  FIXED_INCOME = 2,
}

/**
 * Describes the enum aurora.core.consts.instruments.SecurityCategory.
 */
export const SecurityCategorySchema: GenEnum<SecurityCategory> = /*@__PURE__*/
  enumDesc(file_consts_instrumentconsts, 1);

/**
 * SecurityType represents grouped security types for display and API use.
 * Raw source types (ADRC, ADRP, etc.) are grouped into display types (ADR).
 *
 * @generated from enum aurora.core.consts.instruments.SecurityType
 */
export enum SecurityType {
  /**
   * @generated from enum value: SECURITY_TYPE_UNSPECIFIED = 0;
   */
  SECURITY_TYPE_UNSPECIFIED = 0,

  /**
   * Common Stock
   *
   * @generated from enum value: CS = 1;
   */
  CS = 1,

  /**
   * Preferred Stock
   *
   * @generated from enum value: PFD = 2;
   */
  PFD = 2,

  /**
   * Warrant
   *
   * @generated from enum value: WARRANT = 3;
   */
  WARRANT = 3,

  /**
   * Rights
   *
   * @generated from enum value: RIGHT = 4;
   */
  RIGHT = 4,

  /**
   * Corporate Bond
   *
   * @generated from enum value: BOND = 5;
   */
  BOND = 5,

  /**
   * Exchange Traded Fund
   *
   * @generated from enum value: ETF = 6;
   */
  ETF = 6,

  /**
   * Structured Product
   *
   * @generated from enum value: SP = 7;
   */
  SP = 7,

  /**
   * American Depository Receipt (group: ADRC, ADRP, ADRW, ADRR)
   *
   * @generated from enum value: ADR = 8;
   */
  ADR = 8,

  /**
   * Fund
   *
   * @generated from enum value: FUND = 9;
   */
  FUND = 9,

  /**
   * Basket
   *
   * @generated from enum value: BASKET = 10;
   */
  BASKET = 10,

  /**
   * Unit
   *
   * @generated from enum value: UNIT = 11;
   */
  UNIT = 11,

  /**
   * Liquidating Trust
   *
   * @generated from enum value: LT = 12;
   */
  LT = 12,

  /**
   * Ordinary Shares
   *
   * @generated from enum value: OS = 13;
   */
  OS = 13,

  /**
   * Global Depository Receipts
   *
   * @generated from enum value: GDR = 14;
   */
  GDR = 14,

  /**
   * Other Security Type
   *
   * @generated from enum value: OTHER = 15;
   */
  OTHER = 15,

  /**
   * New York Registry Shares
   *
   * @generated from enum value: NYRS = 16;
   */
  NYRS = 16,

  /**
   * Agency Bond
   *
   * @generated from enum value: AGEN = 17;
   */
  AGEN = 17,

  /**
   * Equity Linked Bond
   *
   * @generated from enum value: EQLK = 18;
   */
  EQLK = 18,

  /**
   * Exchange Traded (group: ETN, ETV, ETS)
   *
   * @generated from enum value: ETS = 19;
   */
  ETS = 19,

  /**
   * Corp Notes
   *
   * @generated from enum value: NT = 20;
   */
  NT = 20,
}

/**
 * Describes the enum aurora.core.consts.instruments.SecurityType.
 */
export const SecurityTypeSchema: GenEnum<SecurityType> = /*@__PURE__*/
  enumDesc(file_consts_instrumentconsts, 2);

